/**
 * Enum for form field type.
 * @readonly
 * @enum {string}
 */
export const FormFieldType = Object.freeze({
  FieldGroup: 'FieldGroup',
  Text: 'Text',
  TextArea: 'TextArea',
  Select: 'Select',
  Date: 'Date',
  DateTime: 'DateTime',
  Email: 'Email',
  Heading: 'Heading',
  Number: 'Number',
  Signature: 'Signature',
  Radio: 'Radio',
  Checkbox: 'Checkbox',
  SelectBox: 'SelectBox',
  Content: 'Content',
  YesNo: 'YesNo',
  StarRating: 'StarRating',
})
